export const formatNumbers = (
  value: number | string,
  locale: 'ar-SA' | 'en-US',
  currency = 'SAR',
) => {
  const number = typeof value === 'number' ? value : Number(value);

  const isInteger = Number.isInteger(number);
  const shouldShowDecimals = !isInteger || currency === 'OMR';

  const options: Intl.NumberFormatOptions = {
    ...(shouldShowDecimals && {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    ...(currency !== 'SAR' && {
      style: 'currency',
      currency,
    }),
  };

  return number
    .toLocaleString(locale, options)
    .replace(/[\p{L}]+(?=\p{Sc})/u, '')
    .trim();
};
